/* Created By CoolGuy on 2017/12/5
*/
import React from 'react';
import {Dialog, Toast} from 'react-weui';
import BasicDialog from '../Dialog/BasicDialog';
import {observer, inject} from 'mobx-react';

@inject("rootStore")
@observer
export default class Common extends React.Component {
    render() {
        const {uiStore} = this.props.rootStore;
        const {toast = {},alert = {},basicDialog={}} = uiStore;
        //console.log(toast,'common');
        return (
            <React.Fragment>
                <Toast show={toast.show} icon={toast.icon} iconSize={toast.iconSize}>{toast.content}</Toast>
                <Dialog type="ios" title={alert.title} buttons={alert.buttons.slice()} show={alert.show}>{alert.content||""}</Dialog>
                <BasicDialog title={basicDialog.title}
                             content={basicDialog.content}
                             show={basicDialog.show}
                             onOk={basicDialog.onOk}
                             okText={basicDialog.okText}
                             cancelText={basicDialog.cancelText}
                             onCancel={basicDialog.onCancel}
                             showCancel={basicDialog.showCancel}/>

            </React.Fragment>
        )

    }
}


// WEBPACK FOOTER //
// ./src/components/Wx/Common.js